import request from '@/utils/request'

//新闻列表
export function news_list(data) {
  return request({
    url: 'news_list',
    method: 'post',
    data:data
  })
}

//详情
export function news_detail(data) {
  return request({
    url: 'news_detail',
    method: 'post',
    data:data
  })
}

//主题列表
export function zhuti_list(data) {
  return request({
    url: 'zhuti_list',
    method: 'post',
    data:data
  })
}

//提交活动
export function user_huodong_save(data){
	return request({
	  url: 'user_huodong_save',
	  method: 'post',
	  data:data
	})
}

//查看自己的活动报名
export function user_baoming_find(data){
	return request({
	  url: 'user_baoming_find',
	  method: 'post',
	  data:data
	})
}

//查看自己的活动报名列表-分页
export function user_baoming_list(data){
	return request({
	  url: 'user_baoming_list',
	  method: 'post',
	  data:data
	})
}

//提交报名
export function user_hdbaoming_save(data){
	return request({
	  url: 'user_hdbaoming_save',
	  method: 'post',
	  data:data
	})
}


// WEBPACK FOOTER //
// ./src/api/news.js